'use strict';

var integrations = require('integrations/productDetail');
integrations.baseFiles.custom = require('./product/custom');

module.exports = integrations;
